import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("aga_cart")) || []; } catch { return []; }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [discount, setDiscount] = useState(() => Number(localStorage.getItem("aga_discount")) || 0);

  useEffect(() => { localStorage.setItem("aga_discount", String(discount)); }, [discount]);

  useEffect(() => { localStorage.setItem("aga_cart", JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.id === product.id);
      if (ex) return prev.map((i) => (i.id === product.id ? { ...i, qty: i.qty + qty } : i));
      return [...prev, { id: product.id, qty }];
    });
    setDrawerOpen(true);
  };
  const setQty = (id, qty) => setItems((prev) => (qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty } : i))));
  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => { setItems([]); setDiscount(0); };
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, drawerOpen, setDrawerOpen, discount, setDiscount }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
